<script setup lang="ts">
import type { ElementsCard } from '@autobid/strapi-integration/rest/components'
import Card from './Card.vue'
import CardButton from './CardButton.vue'
import CardContent from './CardContent.vue'
import CardHeader from './CardHeader.vue'
import CardHeaderIcon from './CardHeaderIcon.vue'
import CardHeaderTitle from './CardHeaderTitle.vue'

interface Props {
  card: ElementsCard
}

const props = defineProps<Props>()
provide('card', props.card)
</script>

<template>
  <Card class="h-full min-h-[8.5rem]">
    <CardHeader>
      <CardHeaderIcon v-if="card.header?.icon" />
      <CardHeaderTitle />
    </CardHeader>
    <CardContent v-if="card.content" />
    <CardButton v-if="card.button" />
  </Card>
</template>
